export const FallbackCryptoPaymentErrorMessage = {
  FailedToGetPaymentLink: 'Failed to get payment link',
};
